module.exports = __webpack_public_path__ + "img/156-ed24c8.png";